import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLikeMarker, curveGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode, PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {BoundaryOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/boundary-operator/geometry-boundary-operator-node"
import {
    GeometryBoundaryOperatorNode,
    boundaryOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/boundary-operator/geometry-boundary-operator-node"

export type PointGeometryBoundaryOperatorParameters = BoundaryOperatorParameters<CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryBoundaryOperatorParameters> = {
    nodeClass: "PointGeometryBoundaryOperator",
    validation: {
        parameters: boundaryOperatorParametersSchema(curveGeometryAttributeLike, curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryBoundaryOperator
    extends GeometryBoundaryOperatorNode<1, CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
